import axios from 'axios';
import { ENDPOINT } from '../constants';

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

const getHeaders = () => {
    let session = sessionStorage.getItem('user');
    //console.log("accessToken",`${JSON.parse(session).accessToken}`);
    if (session && JSON.parse(session)) {
        return {
            'X-AUTH-TOKEN': `Basic:${JSON.parse(session).token}`,
            'Authorization': `Bearer ${JSON.parse(session).token}`,
            'Accept': '*/*',
            'Access-Control-Allow-Origin': '*',
        }
    }
    return {
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
    };
}

const API = {
    get: (url) => axios.get(`${ENDPOINT}${url}`, { headers: getHeaders() }),
    post: (url, data) => axios.post(`${ENDPOINT}${url}`, data, { headers: getHeaders() }),
    delete: (url, data) => axios.delete(`${ENDPOINT}${url}`, { headers: getHeaders() }),
    put: (url, data) => axios.put(`${ENDPOINT}${url}`, data, { headers: getHeaders() })
};

export default API;